import { render } from "./IconShrink.vue?vue&type=template&id=9a2bd5be"
import script from "./IconShrink.vue?vue&type=script&lang=js"
export * from "./IconShrink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__